import React from 'react';
import PropTypes from 'prop-types';
import CountryPageLatestNews from './CountryPageLatestNews';
import Link from 'components/Link';
import NoContent from 'components/NoContent';
import './CountryPageLatestNewsBlock.scss';

const CountryPageLatestNewsBlock = ({
  heading,
  news,
  lang,
  newsArchiveUrl,
}) => {
  return news && news.length > 0 ? (
    <div className="country-page-latest-news-block">
      {heading && (
        <h2 className="country-page-latest-news-block__heading">{heading}</h2>
      )}
      <ul className="country-page-latest-news-block__list">
        {news.map((link, index) => (
          <li className="country-page-latest-news-block__list-item" key={index}>
            <CountryPageLatestNews
              {...link}
              pablishedLabel={lang.publishedLabel}
              headingTagLevel={heading ? 3 : 2}
            />
          </li>
        ))}
      </ul>
      <div className="country-page-latest-news-block__archive-link-holder">
        <Link text={lang.newsArchiveUrlLabel} url={newsArchiveUrl} />
      </div>
    </div>
  ) : (
    <NoContent
      heading={heading}
      message={lang.noContentMessage}
      link={{
        text: lang.newsArchiveUrlLabel,
        url: newsArchiveUrl,
      }}
    />
  );
};

CountryPageLatestNewsBlock.propTypes = {
  heading: PropTypes.string,
  news: PropTypes.arrayOf(PropTypes.exact(CountryPageLatestNews.propTypes))
    .isRequired,
  lang: PropTypes.shape({
    newsArchiveUrlLabel: PropTypes.string.isRequired,
    publishedLabel: PropTypes.string.isRequired,
    noContentMessage: PropTypes.string.isRequired,
  }).isRequired,
  newsArchiveUrl: PropTypes.string,
};

export default CountryPageLatestNewsBlock;
